import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Login } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

  url = environment.url3 + '/login';

  constructor(private http: HttpClient) {}

  // getLogin(login: Login) {
   
  //   let headers = new HttpHeaders()
  //   .append('Content-Type', 'application/json')
  //   .append('Access-Control-Allow-Origin', environment.urlLocal);
  //   console.log(login.username);
  //   console.log(login.password);
  //   console.log('Inside login service');
  //   console.log(headers);
  //   console.trace();
  //   return this.http.get(`${ this.url }/login?username=${ login.username }&password=${ login.password }`, { headers }).pipe( map( data => data));
  // }

  getLogin(login: Login) {
    let headers = new HttpHeaders()
        .append('Content-Type', 'application/json')
        .append('Access-Control-Allow-Origin', environment.urlLocal);

    console.log(login);    
    console.log(login.username);
    console.log(login.password);
    console.log('Inside login service');
    console.log('headers: -> ');
    console.log(headers);
    console.trace();

    // Use POST instead of GET and send the login object in the body
    return this.http.post(`${this.url}/login`, login, { headers }).pipe(
        map(data => data)
    );
    }


}
